import * as React from 'react';
import { Tooltip } from 'reactstrap';

interface Props {
    targetId: string;
    text: string;
}

interface State {
    tooltipOpen: boolean;
}

export default class HoverTooltip extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            tooltipOpen: false
        };
    }

    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    render() {
        return (
            <Tooltip
                placement="bottom"
                isOpen={this.state.tooltipOpen}
                target={this.props.targetId}
                toggle={this.toggle}
            >
                {this.props.text}
            </Tooltip>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/HoverTooltip.tsx